/** Stroke icons for the Icon block (24×24 viewBox, Feather-style). */
export var BLOCK_ICON_CATALOG = [{
  id: "star",
  label: "Star",
  keywords: "star favorite rating",
  paths: ["M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"]
}, {
  id: "heart",
  label: "Heart",
  keywords: "heart love like",
  paths: ["M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"]
}, {
  id: "check",
  label: "Check",
  keywords: "check tick done",
  paths: ["M20 6L9 17l-5-5"]
}, {
  id: "check-circle",
  label: "Check Circle",
  keywords: "check circle success",
  paths: ["M22 11.08V12a10 10 0 1 1-5.93-9.14", "M22 4L12 14.01l-3-3"]
}, {
  id: "x",
  label: "Close",
  keywords: "x close cancel",
  paths: ["M18 6L6 18", "M6 6l12 12"]
}, {
  id: "alert-circle",
  label: "Alert",
  keywords: "alert warning",
  paths: ["M12 8v4", "M12 16h.01", "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"]
}, {
  id: "info",
  label: "Info",
  keywords: "info help",
  paths: ["M12 16v-4", "M12 8h.01", "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z"]
}, {
  id: "bell",
  label: "Bell",
  keywords: "bell notification",
  paths: ["M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9", "M13.73 21a2 2 0 0 1-3.46 0"]
}, {
  id: "mail",
  label: "Mail",
  keywords: "mail email envelope",
  paths: ["M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z", "M22 6l-10 7L2 6"]
}, {
  id: "phone",
  label: "Phone",
  keywords: "phone call",
  paths: ["M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"]
}, {
  id: "map-pin",
  label: "Location",
  keywords: "map pin location",
  paths: ["M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z", "M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"]
}, {
  id: "globe",
  label: "Globe",
  keywords: "globe web world",
  paths: ["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z", "M2 12h20", "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"]
}, {
  id: "link",
  label: "Link",
  keywords: "link url chain",
  paths: ["M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71", "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"]
}, {
  id: "home",
  label: "Home",
  keywords: "home house",
  paths: ["M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z", "M9 22V12h6v10"]
}, {
  id: "user",
  label: "User",
  keywords: "user person profile",
  paths: ["M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2", "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"]
}, {
  id: "users",
  label: "Users",
  keywords: "users team group",
  paths: ["M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2", "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z", "M23 21v-2a4 4 0 0 0-3-3.87", "M16 3.13a4 4 0 0 1 0 7.75"]
}, {
  id: "calendar",
  label: "Calendar",
  keywords: "calendar date schedule",
  paths: ["M19 4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z", "M16 2v4", "M8 2v4", "M3 10h18"]
}, {
  id: "clock",
  label: "Clock",
  keywords: "clock time",
  paths: ["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z", "M12 6v6l4 2"]
}, {
  id: "settings",
  label: "Settings",
  keywords: "settings gear cog",
  paths: ["M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"]
}, {
  id: "tool",
  label: "Tool",
  keywords: "tool wrench settings",
  paths: ["M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"]
}, {
  id: "search",
  label: "Search",
  keywords: "search find magnify",
  paths: ["M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z", "M21 21l-4.35-4.35"]
}, {
  id: "upload",
  label: "Upload",
  keywords: "upload arrow",
  paths: ["M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", "M17 8l-5-5-5 5", "M12 3v12"]
}, {
  id: "download",
  label: "Download",
  keywords: "download arrow",
  paths: ["M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", "M7 10l5 5 5-5", "M12 15V3"]
}, {
  id: "image",
  label: "Image",
  keywords: "image photo picture",
  paths: ["M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z", "M8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"]
}, {
  id: "file",
  label: "File",
  keywords: "file document",
  paths: ["M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z", "M14 2v6h6"]
}, {
  id: "folder",
  label: "Folder",
  keywords: "folder directory",
  paths: ["M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"]
}, {
  id: "edit",
  label: "Edit",
  keywords: "edit pencil write",
  paths: ["M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"]
}, {
  id: "trash",
  label: "Trash",
  keywords: "trash delete remove",
  paths: ["M3 6h18", "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"]
}, {
  id: "copy",
  label: "Copy",
  keywords: "copy duplicate",
  paths: ["M16 16v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2", "M10 6h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"]
}, {
  id: "lock",
  label: "Lock",
  keywords: "lock secure private",
  paths: ["M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z", "M7 11V7a5 5 0 0 1 10 0v4"]
}, {
  id: "unlock",
  label: "Unlock",
  keywords: "unlock open",
  paths: ["M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z", "M7 11V7a5 5 0 0 1 9.9-1"]
}, {
  id: "eye",
  label: "Eye",
  keywords: "eye view show",
  paths: ["M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z", "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"]
}, {
  id: "zap",
  label: "Zap",
  keywords: "zap lightning bolt energy",
  paths: ["M13 2L3 14h9l-1 8 10-12h-9l1-8z"]
}, {
  id: "award",
  label: "Award",
  keywords: "award badge medal",
  paths: ["M12 15l-2 5 2-1 2 1-2-5", "M8.21 13.89L7 23l5-3 5 3-1.21-9.11", "M12 15a7 7 0 1 0 0-14 7 7 0 0 0 0 14z"]
}, {
  id: "gift",
  label: "Gift",
  keywords: "gift present",
  paths: ["M20 12v10H4V12", "M2 7h20v5H2z", "M12 22V7", "M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z", "M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"]
}, {
  id: "target",
  label: "Target",
  keywords: "target goal aim",
  paths: ["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z", "M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12z", "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"]
}, {
  id: "trending-up",
  label: "Trending Up",
  keywords: "trending growth chart",
  paths: ["M23 6l-9.5 9.5-5-5L1 18", "M17 6h6v6"]
}, {
  id: "bar-chart",
  label: "Bar Chart",
  keywords: "chart bar analytics",
  paths: ["M12 20V10", "M18 20V4", "M6 20v-4"]
}, {
  id: "dollar-sign",
  label: "Dollar",
  keywords: "dollar money currency",
  paths: ["M12 1v22", "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"]
}, {
  id: "credit-card",
  label: "Credit Card",
  keywords: "card payment credit",
  paths: ["M21 4H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z", "M1 10h22"]
}, {
  id: "shopping-cart",
  label: "Cart",
  keywords: "cart shop buy",
  paths: ["M6 6h15l-1.5 9h-12z", "M6 6l-2-3H1", "M9 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2z", "M20 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"]
}, {
  id: "package",
  label: "Package",
  keywords: "package box delivery",
  paths: ["M16.5 9.4l-9-5.19", "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z", "M3.27 6.96L12 12.01l8.73-5.05", "M12 22.08V12"]
}, {
  id: "bookmark",
  label: "Bookmark",
  keywords: "bookmark save",
  paths: ["M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"]
}, {
  id: "flag",
  label: "Flag",
  keywords: "flag report",
  paths: ["M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z", "M4 22v-7"]
}, {
  id: "message",
  label: "Message",
  keywords: "message chat comment",
  paths: ["M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"]
}, {
  id: "send",
  label: "Send",
  keywords: "send share paper plane",
  paths: ["M22 2L11 13", "M22 2l-7 20-4-9-9-4 20-7z"]
}, {
  id: "share",
  label: "Share",
  keywords: "share network",
  paths: ["M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", "M16 6l-4-4-4 4", "M12 2v13"]
}, {
  id: "thumbs-up",
  label: "Thumbs Up",
  keywords: "thumbs like approve",
  paths: ["M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z", "M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"]
}, {
  id: "camera",
  label: "Camera",
  keywords: "camera photo",
  paths: ["M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z", "M12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"]
}, {
  id: "video",
  label: "Video",
  keywords: "video film play",
  paths: ["M23 7l-7 5 7 5V7z", "M14 5H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z"]
}, {
  id: "play",
  label: "Play",
  keywords: "play start media",
  paths: ["M5 3l14 9-14 9V3z"]
}, {
  id: "music",
  label: "Music",
  keywords: "music note audio",
  paths: ["M9 18V5l12-2v13", "M9 18a3 3 0 1 1-6 0 3 3 0 0 1 6 0z", "M21 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"]
}, {
  id: "book",
  label: "Book",
  keywords: "book read learn",
  paths: ["M4 19.5A2.5 2.5 0 0 1 6.5 17H20", "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"]
}, {
  id: "briefcase",
  label: "Briefcase",
  keywords: "briefcase work business",
  paths: ["M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z", "M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"]
}, {
  id: "building",
  label: "Building",
  keywords: "building office company",
  paths: ["M3 21h18", "M5 21V7l8-4v18", "M19 21V11l-6-4", "M9 9h1", "M9 13h1", "M9 17h1"]
}, {
  id: "sun",
  label: "Sun",
  keywords: "sun light day",
  paths: ["M12 1v2", "M12 21v2", "M4.22 4.22l1.42 1.42", "M18.36 18.36l1.42 1.42", "M1 12h2", "M21 12h2", "M4.22 19.78l1.42-1.42", "M18.36 5.64l1.42-1.42", "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"]
}, {
  id: "moon",
  label: "Moon",
  keywords: "moon night dark",
  paths: ["M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"]
}, {
  id: "cloud",
  label: "Cloud",
  keywords: "cloud weather",
  paths: ["M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"]
}, {
  id: "coffee",
  label: "Coffee",
  keywords: "coffee cup drink",
  paths: ["M18 8h1a4 4 0 0 1 0 8h-1", "M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z", "M6 1v3", "M10 1v3", "M14 1v3"]
}, {
  id: "smile",
  label: "Smile",
  keywords: "smile happy face",
  paths: ["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z", "M8 14s1.5 2 4 2 4-2 4-2", "M9 9h.01", "M15 9h.01"]
}];
export var ICON_EMOJI_PRESETS = ["★", "☆", "⭐", "🌟", "✨", "💫", "❤️", "🔥", "⚡", "💡", "🚀", "🎯", "📈", "📊", "💼", "💎", "🏆", "👑", "✔️", "❌", "⚠️", "ℹ️", "❓", "🔔", "✉️", "📞", "💬", "📣", "🌐", "📍", "⚙️", "🛠️", "📅", "🕒", "🔒", "🔑", "👤", "👥", "🏠", "👍", "👎", "🔗", "➡️", "⬅️", "⬆", "⬇", "🧭", "🍎", "✅", "💰", "🎁", "📎", "🖊️", "📝"];
export function findBlockIcon(id) {
  return BLOCK_ICON_CATALOG.find(function (icon) {
    return icon.id === id;
  }) || null;
}
export function filterBlockIcons() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var q = String(query || "").trim().toLowerCase();
  if (!q) return BLOCK_ICON_CATALOG;
  return BLOCK_ICON_CATALOG.filter(function (icon) {
    var haystack = "".concat(icon.id, " ").concat(icon.label, " ").concat(icon.keywords || "").toLowerCase();
    return haystack.includes(q);
  });
}